import { render, staticRenderFns } from "./AgendaAppuntamentoAccettazioneBoxModalComponent.vue?vue&type=template&id=2e3fe610"
import script from "./AgendaAppuntamentoAccettazioneBoxModalComponent.vue?vue&type=script&lang=js"
export * from "./AgendaAppuntamentoAccettazioneBoxModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports